module.exports = __webpack_public_path__ + "img/face-id.030452a5.svg";